const styles = {
	topbarStatus: {
		color: 'white',
		paddingY: '7px',
		fontSize: 0,
		fontWeight: 600,
		textAlign: 'center',
		backgroundColor: 'primary',
	},
	topbar: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		minHeight: 80,
		borderBottomWidth: 1,
		borderBottomStyle: 'solid',
		borderBottomColor: 'muted',
		backgroundColor: 'white',
		'> div': {
			paddingLeft: [10, 20],
			paddingRight: 20,
		},
		'@media only screen and (max-width: 991px)': {
			borderBottom: 0,
			boxShadow: '0 2px 4px rgba(41,41,41,0.06)',
		},
		'.logo a': {
			position: 'relative',
			marginTop: '6px',
			marginRight: '30px',
			'@media only screen and (max-width: 991px)': {
				marginLeft: '10px',
				marginRight: '0',
			},
			'@media only screen and (max-width: 667px)': {
				img: {
					width: 86,
				},
			},
		},
		'@media only screen and (max-width: 667px)': {
			'&.mobileSearch': {
				'&::after': {
					content: '""',
					display: 'block',
					width: '100vw',
					height: 'calc(100vh - 80px)',
					position: 'fixed',
					left: 0,
					top: 80,
					backgroundColor: 'rgba(0, 0, 0, 0.2)',
					zIndex: 2,
					backdropFilter: 'blur(2px)',
				},
			},
		},
	},
	grid: {
		gridGap: [10, 30, 40],
		alignItems: 'center',
		gridTemplateColumns: 'auto 1fr auto',
		'@media only screen and (max-width: 667px)': {
			gridTemplateColumns: '1fr auto auto',
		},
		'.search': {
			display: 'flex',
			maxWidth: 480,
			marginLeft: 'auto',
			'@media only screen and (max-width: 667px)': {
				display: 'none',
			},
		},
	},
	hamburgBtn: {
		display: 'none',
		'@media only screen and (max-width: 991px)': {
			display: 'inline-flex',
		},
	},
	searchBtn: {
		display: 'none',
		svg: { width: 24 },
		'@media only screen and (max-width: 667px)': {
			display: 'inline-flex',
		},
	},
	rightPart: {
		display: 'flex',
		alignItems: 'center',
		div: {
			marginTop: '2px',
		},
		a: {
			display: 'flex',
			color: 'primary',
			textDecoration: 'none',
			transition: 'color 0.2s',
			svg: {
				width: [22, 20],
				height: 'auto',
			},
			':hover': {
				color: 'menu',
			},
		},
	},
	drawerTitle: {
		paddingY: 20,
		paddingLeft: 30,
		paddingRight: 20,
		alignItems: 'center',
		justifyContent: 'space-between',
		backgroundColor: 'background',
		h2: {
			color: 'primary',
			fontSize: 17,
		},
	},
};

export default styles;
